import { TAB_CATEGORY } from '@/constant/permission'
import BlankLayout from '../../layout/blankLayout.vue'
import resumeEditor from './editor.vue'

const applicationRoute = {
  path: '/v-admin/talent-pool/candidate/:candidateId',
  component: BlankLayout,
  redirect: '/v-admin/talent-pool/candidate/:candidateId/edit',
  meta: {
    permission: TAB_CATEGORY.TALENT_POOL,
    titleI18nKey: 'admin.candidate.title',
    tab: 'admin.candidate.tab'
  },
  children: [
    {
      name: 'talentPoolCandidateEditor',
      path: '/v-admin/talent-pool/candidate/:candidateId/edit',
      component: resumeEditor,
      meta: {
        isEditMode: true,
        titleI18nKey: 'admin.application.candidate.title.editCandidate'
      }
    }
  ]
}
export default applicationRoute
